let url =
  process.env.ENVIRONMENT === 'STG'
    ? 'https://l60xo7vpwj.execute-api.us-east-1.amazonaws.com/stg/nol'
    : process.env.ENVIRONMENT === 'PDN'
      ? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/nol'
      : 'https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/nol'

export const CLIENT_ID =
  process.env.ENVIRONMENT !== 'PDN'
    ? '10prlbiado4ieqmmv31nedlbc'
    : '4l2ebk4ltfhfu0dnhais1l2qhs'
export const REFRESH_TOKEN =
  process.env.ENVIRONMENT !== 'PDN'
    ? 'https://nol-dev.auth.us-east-1.amazoncognito.com/oauth2/token'
    : 'https://nol-pdn.auth.us-east-1.amazoncognito.com/oauth2/token'

//register
export const stateUser = url + '/register/api/v1/status'

//authentication
export const authentication = url + '/authentication/api/v1/auth'
export const recoverPass = url + '/recovery/api/v1/recovery'
export const restorePassToken = url + '/recovery/api/v1/change'
export const restorePass = url + '/recovery/api/v1/change-recovery'

//account
export const accountInfo = url + '/account/api/v1/user'
export const accountUpdate = url + '/account/api/v1/account'
export const pictureUpdate = url + '/account/api/v1/picture'
export const otpSend = url + '/otp/api/v1/otp'
export const otpValidate = url + '/otp/api/v1/verify-otp'
export const getRequestEmailchange = url + '/account/api/v1/emailChange'
export const createRequestEmailChange = url + '/account/api/v1/emailChange'
export const delateRequestEmailChange = url + '/account/api/v1/emailChange'
export const confirmEmailChange = url + '/account/api/v1/emailChange/confirm'
export const sendOtpEmailChange = url + '/otp/api/v1/otp/email'
export const validateBirthdate = url + '/account/api/v1/validate/birthdate'

//samples
export const createSample = url + '/v-confident/api/v1/create-sample'
export const validateSample = url + '/v-confident/api/v1/last-request-sample'

//data policy service
export const dataPolicy = url + '/account/api/v1/data-policy'

// Get ip Address
export const GET_IP_ADDRESS = 'https://jsonip.com/'

// Google API KEY
export const GOOGLE_API_KEY = 'AIzaSyCN8ZrJwdNr5hJ4FkpgwMR6qzH1KS4TWlg'
export const GOOGLE_API_KEY_II = 'AIzaSyBfSCVlIfp7EEmQP9r68O2ffRrpMqA1Qn0'
